// extracted by mini-css-extract-plugin
export default {"cls1":"RsBmEkAnnKkgONqpz1Qw","cls2":"PdCNiDTNv8f6s1ssJY7J RsBmEkAnnKkgONqpz1Qw","timeNotation-12h":"nalzJvQqlJAyMPVTnDKc","timeNotation-24h":"eQY2UIm0qr3D1UQaDBiw"};